import { Box, Typography, Button, Stack } from '@mui/material';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { CloseSessionSVG, NaturaSVG } from '@ui/components';
import { useTranslation } from 'react-i18next';
import LanguageSelector from '@ui/components/languageSelector';

export function Header () {
    const history = useHistory();
    const { t } = useTranslation();
    const logout = () => {
        localStorage.removeItem('sessionUser');
        localStorage.removeItem('newEmail');
        history.push('/logout');
    };

    return (
        <Box className='header'>
            <Box className='naturaIcon'>
                <NaturaSVG/>
            </Box>
            <Stack direction={'row'} alignItems={'center'} justifyContent={'center'} marginLeft={'auto'} spacing={'1rem'}>
                <Button sx={{ textTransform: 'none' }} onClick={logout}>
                    <CloseSessionSVG/>
                    <Typography variant='sessionClose' className='sessionButton ml-2'>{t('logout')}</Typography>
                </Button>
                <div className='d-flex align-items-center'>
                    <LanguageSelector/>
                </div>
            </Stack>
        </Box>
    );
}
